import { makeStyles } from "@material-ui/core/styles";
import { view } from "@risingstack/react-easy-state";
import { clsx } from "clsx";
import React, { useMemo } from "react";
import { formatToCurrencyString } from "../../../../../../../helpers";
import transactionDetails from "../../../../../../../store/modules/transactionDetails";
import { MigomTable } from "../../../../../../System";
import LazyImage from "../../../../../../System/LazyImage";

const useStyles = makeStyles({
  isPending: {
    opacity: 0.5,
  },
});

const RelatedFx = view(() => {
  const classes = useStyles();
  const { adminRelatedFx, fetchUserAccountTransaction } = transactionDetails;

  const columns = useMemo(() => {
    return [
      {
        Header: "Account Owner",
        id: "adminAccountOwner",
        width: 300,
        accessor: (rowData) => {
          return (
            <span
              className={clsx(
                "whitespace-nowrap flex",
                rowData.isPending ? "opacity-50" : "opacity-100"
              )}
            >
              {rowData.adminAccountOwner}
              {rowData.adminFeeId === "MARKUP" && (
                <div className="w-6">
                  <LazyImage
                    src="/images/fear.svg"
                    classNameImageBlock="max-w-full"
                  />
                </div>
              )}
            </span>
          );
        },
      },
      {
        Header: "Description",
        id: "comment",
        accessor: (rowData) => {
          return (
            <span
              className={clsx(
                "break-words",
                rowData.isPending ? "opacity-50" : "opacity-100"
              )}
              dangerouslySetInnerHTML={{
                __html: (rowData.comment || "").replace(
                  /`([^"]+)`/g,
                  `<span style="border: 1px solid #ccc; padding: 2px 4px;">$1</span>`
                ),
              }}
            />
          );
        },
      },
      {
        Header: "Amount",
        id: "amount",
        styleHead: {
          textAlign: "right",
        },
        style: {
          textAlign: "right",
        },
        accessor: (rowData) => {
          const { amount, currencyId } = rowData;

          return (
            <div className={rowData.isPending ? "opacity-50" : "opacity-100"}>
              <b
                className={amount && amount > 0 ? "text-main" : "text-gray-500"}
              >
                {formatToCurrencyString(amount, currencyId)}
              </b>
            </div>
          );
        },
      },
    ];
  }, []);

  const memoData = useMemo(() => {
    return adminRelatedFx || [];
  }, [adminRelatedFx]);

  const makeRowClass = (row) => {
    if (row.isPending === "true") {
      return classes.isPending;
    }
    return null;
  };

  const onRow = (rowData) => {
    transactionDetails.clearTransaction();
    fetchUserAccountTransaction(rowData.isPending, rowData.operationId);
  };

  return memoData?.length > 0 ? (
    <>
      <div className="h-8" />

      <div className="mb-4">
        <h2 className="m-0 p-0">Other operations in this transaction (FX)</h2>
      </div>

      <MigomTable
        columns={columns}
        data={memoData}
        makeRowClass={makeRowClass}
        hidePagination
        onRowClick={onRow}
        autoHeight
      />
    </>
  ) : null;
});

export default RelatedFx;
